import { AppRoute } from '@agentselly/immodossier-shared';
import { cockpitDocumentsWidgets } from '~/components/widget/config/cockpitDocumentsWidgets';
import { makeQueryLoaderWidgetsRoute } from '~/helper/makeQueryLoaderWidgetsRoute';

export const Route = makeQueryLoaderWidgetsRoute(
  AppRoute.$LANG_$COMPANYID_PUBLIC_DEMO_COCKPIT_DOCUMENTS,
  cockpitDocumentsWidgets,
  true,
);
